import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/QAListManagerment';

function* getListQA(action) {
    const endpoint = `/api/v1/event/${action.payload.event_name}/qa/`;
    try {
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                body: {
                    qa_type: action.payload.qa_type,
                    ...{ ...action.payload.language && { language: action.payload.language } },
                },
            },
        );
        yield put(Actions.GetListQARequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetListQARequestedReceivedFailure(yield error));
    }
}
function* createListQA(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/qa/`;
        const resultsState = action.payload.curentList;
        const response = yield call(
            API.post, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {
                    type: action.payload.qa_type,
                    question: action.payload.question,
                    answer: action.payload.answer,
                    language: action.payload?.language || 'ja',
                },
            },
        );
        let dataResult = [];
        if (resultsState) {
            for (let i = 0; i < resultsState.length; i += 1) {
                if (i === action.payload.index) {
                    dataResult.push(response);
                } else {
                    dataResult.push(resultsState[i]);
                }
            }
        } else {
            dataResult = response;
        }
        yield put(Actions.createQARequestedReceived(dataResult));
    } catch (error) {
        yield put(Actions.createQARequestedReceivedFailure(yield error));
    }
}
function* updateListQA(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/qa/${action.payload.qa_id}/`;
        const resultsState = action.payload.curentList;
        const response = yield call(
            API.put, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {
                    type: action.payload.qa_type,
                    question: action.payload.question,
                    answer: action.payload.answer,
                    language: action.payload?.language || 'ja',
                },
            },
        );
        let dataResult = [];
        if (resultsState) {
            for (let i = 0; i < resultsState.length; i += 1) {
                if (resultsState[i].id === response.id) {
                    dataResult.push(response);
                } else {
                    dataResult.push(resultsState[i]);
                }
            }
        } else {
            dataResult = response;
        }
        yield put(Actions.updateQARequestedReceived(dataResult));
    } catch (error) {
        yield put(Actions.updateQARequestedReceivedFailure(yield error));
    }
}
function* deleteListQA(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/qa/${action.payload.qa_id}/`;
        const resultsState = action.payload.curentList;
        const response = yield call(
            API.delete, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
            },
        );
        let dataResult = [];
        if (response) {
            dataResult = resultsState.filter((item) => item.id !== action.payload.qa_id);
        } else {
            dataResult = resultsState;
        }
        yield put(Actions.deleteQARequestedReceived(dataResult));
    } catch (error) {
        yield put(Actions.deleteQARequestedReceivedFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeLatest('GET_LIST_QA_REQUESTED', getListQA),
        takeLatest('CREATE_QA_REQUESTED', createListQA),
        takeLatest('UPDATE_QA_REQUESTED', updateListQA),
        takeLatest('DELETE_QA_REQUESTED', deleteListQA),
    ]);
}
